import { render, staticRenderFns } from "./RelationTaskSearch.vue?vue&type=template&id=6b30de4f&scoped=true&"
import script from "./RelationTaskSearch.vue?vue&type=script&lang=js&"
export * from "./RelationTaskSearch.vue?vue&type=script&lang=js&"
import style0 from "./RelationTaskSearch.vue?vue&type=style&index=0&id=6b30de4f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b30de4f",
  null
  
)

export default component.exports